<template>
    <div class="calculation-result" v-if="step === 4">
        <v-row>
            <v-col cols="12" class="col-sm-2 pt-6" order="2" order-sm="1">
                <span class="font-weight-medium">{{$t('culture')}}:</span>
            </v-col>
            <v-col cols="12" class="col-sm-6" order="3" order-sm="2">
                <v-tabs
                    v-model="activeTab"
                    active-class="font-weight-bold text--main-yellow"
                    slider-color="orange lighten-2"
                    background-color="transparent"
                    ref="tabs"
                >
                    <v-tab
                        v-for="(item, idx) in calculatorData"
                        :key="idx"
                        class=" body-1 text-capitalize"
                    >{{getCultureName(item.cultureId)}}</v-tab>
                </v-tabs>
            </v-col>
            <v-col cols="12" class="col-sm-4" order="1" order-sm="3">
                <div class="d-flex justify-end">
                    <v-btn
                        fab
                        medium
                        dark
                        top
                        right
                        color="orange lighten-2"py-sm-5
                        class="mx-1"
                        @click="shareLink"
                        id="share"
                    >
                        <v-icon>{{ 'mdi-share-variant' }}</v-icon>
                    </v-btn>
                    <v-btn
                        fab
                        medium
                        dark
                        top
                        right
                        color="orange lighten-2"
                        class="mx-1"
                        @click="exportToXls"
                        id="export"
                    >
                        <v-icon>{{ 'mdi-download-outline' }}</v-icon>
                    </v-btn>
                    <v-btn
                        fab
                        medium
                        dark
                        top
                        right
                        color="orange lighten-2"
                        class="mx-1"
                        @click="toFirstStep"
                        id="edit"
                    >
                        <v-icon>{{ 'mdi-pencil-outline' }}</v-icon>
                    </v-btn>
                </div>
            </v-col>
        </v-row>
        <v-tabs-items
            v-model="activeTab"
            class="transparent"
        >
            <culture-tab
                v-if="results.length > 0"
                v-for="(calculation, idx) in calculatorFullData"
                :key="idx"
                :calculationIdx="idx"
                :results="results[idx]"
                :cultures="cultures"
                :categories="categories"
                :attributes="attributes"
                @recalculate="$emit('recalculate')"
                @set-selected-products="setProducts"
            ></culture-tab>
        </v-tabs-items>
    </div>
</template>

<script>
import CalculatorDataProvider from "../../../../app-front/mixins/CalculatorDataProvider";
import CultureTab from "./CultureTabResult";
export default {
    name: "ResultsStep",
    components: { CultureTab },
    mixins: [CalculatorDataProvider],
    props: [ 'cultures', 'step', 'results', 'categories', 'attributes' ],
    data() {
        return {
            activeTab: 0,
            commonResults: [],
        }
    },
    computed: {
        calculatorData() {
            return this.calculatorFullData;
        }
    },
    methods: {
        getCultureName(cultureId) {
            const culture =  this.cultures.find(item => item.id === cultureId);
            return culture ? culture.cultureName : '---';
        },
        setProducts(data) {
            this.commonResults = [...data]
        },
        addAllToBasket() {
            this.$emit('add-all-to-basket');
        },
        shareLink() {
            this.$emit('shareLink');
        },
        exportToXls() {
            this.$emit('export-to-xlsx', this.commonResults);
        },
        toFirstStep() {
            this.$emit('to-first-step')
        },
    }
}
</script>

<style scoped>
@media screen and (min-device-width: 1904px) {
    .calculation-result {
        margin-left: 100px !important;
        margin-right: 100px !important;
    }

}

#fab{
    position: fixed;
    bottom: 45px;
    right: 16px;
    z-index: 6;
}
</style>
